import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=50d1e730&scoped=true"
import script from "./UserGroup.vue?vue&type=script&lang=js"
export * from "./UserGroup.vue?vue&type=script&lang=js"
import style0 from "./UserGroup.vue?vue&type=style&index=0&id=50d1e730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1e730",
  null
  
)

export default component.exports